import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import { House, Buildings, Warehouse, MapPin, Door } from "@phosphor-icons/react";

const fmt = (n) => new Intl.NumberFormat("de-DE").format(n || 0);
const iconFor = (t) => t === "apartment" ? Buildings : t === "warehouse" ? Warehouse : House;

export default function Properties() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/character/properties").then(r => setItems(r.data)).catch(() => toast.error("Fehler beim Laden"));
  }, []);

  const totalValue = items.reduce((a, b) => a + (b.price || 0), 0);

  return (
    <div>
      <PageHeader
        eyebrow="03 // REAL ESTATE"
        title="Immobilien"
        description="Häuser, Apartments und Lagerhallen im Besitz deines Chars."
        right={
          <div className="font-mono text-right">
            <div className="text-[10px] text-white/40 uppercase tracking-widest">Portfolio-Wert</div>
            <div className="text-3xl font-black text-volt" data-testid="prop-total-value">${fmt(totalValue)}</div>
          </div>
        }
      />

      <div className="p-4 md:p-8 lg:p-12">
        <div className="grid md:grid-cols-2 gap-4 stagger">
          {items.map(p => {
            const Icon = iconFor(p.type);
            return (
              <div key={p.id} data-testid={`prop-${p.id}`} className="border border-tactical-border bg-tactical-surface p-6 hover:border-white/30 transition-colors duration-150">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-14 h-14 border border-tactical-border bg-tactical-elev flex items-center justify-center flex-shrink-0">
                    <Icon size={26} weight="duotone" className="text-volt" />
                  </div>
                  <div className="flex-1">
                    <div className="font-mono text-[10px] text-white/40 uppercase tracking-widest">{p.type}</div>
                    <div className="font-display font-bold text-xl">{p.label}</div>
                    <div className="flex items-center gap-1 font-mono text-xs text-white/50 mt-1">
                      <MapPin size={12} /> {p.address}
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4 pt-4 border-t border-tactical-border">
                  <div>
                    <div className="font-mono text-[10px] text-white/40 uppercase tracking-widest">Kaufpreis</div>
                    <div className="font-mono font-bold text-lg text-tactical-success">${fmt(p.price)}</div>
                  </div>
                  <div>
                    <div className="font-mono text-[10px] text-white/40 uppercase tracking-widest flex items-center gap-1"><Door size={11} /> Räume</div>
                    <div className="font-mono font-bold text-lg">{p.rooms}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {items.length === 0 && (
          <div className="text-center py-16 font-mono text-white/40 border border-tactical-border border-dashed">
            Noch keine Immobilien im Besitz
          </div>
        )}
      </div>
    </div>
  );
}
